<div style="padding: 30px;">
  <!-- Header -->
  <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid var(--green-800);margin-bottom: 40px;">
    <h2 style="font-family: ABC Arizona Flare; font-size: 30px; font-weight: 400; color: var(--green-700);">Invoice Settings</h2>
    <div style="display: flex; gap: 20px; align-items: center; margin-bottom: 30px;">
      <button class="btn-soft-secondary" style="height: 34px; padding: 0px; margin-top: 10px;" (click)="handleCancelChanges()">View & Manage Invoices</button>
      <button class="btn-core" (click)="onCreateInvoiceClicked()">Create Invoice</button>
    </div>
  </div>

  <!--Content-->
  <div>
    <div class="cpo-section-container">
      <h2 class="cpo-section-title">Payment Notifications</h2>
      <div style="display: flex; justify-content: space-between; padding-left: 60px; padding-right: 60px; padding-top: 10px;">
        <app-checkbox
        [label]="'Send Customer a receipt via email'"
        [(ngModel)]="this.invoiceSettings.customerReceiptEmail"
        > 
        </app-checkbox>
        <app-checkbox
        [label]="'Send Merchant a copy of the receipt'"
        [(ngModel)]="this.invoiceSettings.merchantReceiptEmail"
        > 
        </app-checkbox>
      </div>
    </div>
    <div class="cpo-section-container">
      <h2 class="cpo-section-title">Invoice Number</h2>
      <div style="display: flex; justify-content: space-between; padding-left: 60px; padding-right: 60px; padding-top: 10px; width: 60%;">
        <app-radio-group
        [options]="this.invoiceNumberOptions"
        [(ngModel)]="this.invoiceNumberMode"
        (ngModelChange)="changeInvoiceNumberMode($event)"
        >
        </app-radio-group>
      </div>
    </div>
    <!--Installment Payment needs fleshed out-->
    <!-- <div class="cpo-section-container">
      <h2 class="cpo-section-title">Installment Payment</h2>
      <div style="display: flex; padding-left: 60px; padding-right: 60px; padding-top: 10px;">
        <app-selectbox
        [label]="'Installment Type'"
        [style]="{ width: '300px'}"
        ></app-selectbox>
        <app-selectbox
        [label]="'Payment Frequency'"
        [style]="{ width: '300px'}"
        ></app-selectbox>
      </div>
    </div> -->
    <div class="cpo-section-container">
      <h2 class="cpo-section-title">Email Reminder Frequency</h2>
      <div style="display: flex; padding-left: 60px; padding-right: 60px; padding-top: 10px;">
        <app-selectbox
        [label]="'Frequency'"
        [options]="emailReminderFrequencyOptions"
        [(ngModel)]="this.invoiceSettings.reminderFrequency"
        [style]="{ width: '300px'}"
        ></app-selectbox>
        <app-textbox
        [label]="'Every X Days'"
        [readonly]="this.invoiceSettings.reminderFrequency != 'custom'"
        [(ngModel)]="this.invoiceSettings.reminderFrequencyCustomDays"
        [type]="inputTextModes.Numeric"
        [showDefaultValue]="false"
        [style]="{ width: '300px'}"
        ></app-textbox>
      </div>
    </div>
    <div class="cpo-section-container">
      <h2 class="cpo-section-title">Email Templates</h2>
      <div style="display: flex; flex-direction: column; gap: 10px; padding-left: 60px; padding-right: 60px; padding-top: 10px;">
        <app-multiline
          [label]="'Initial Notification'"
          [(ngModel)]="this.invoiceSettings.initialNotification"
          (onChanged)="handleTemplateChanged($event, 'initial')"
        ></app-multiline>
        <app-multiline
          [label]="'Subsequent Notification'"
          [(ngModel)]="this.invoiceSettings.subsequentNotification"
          (onChanged)="handleTemplateChanged($event, 'subsequent')"
        ></app-multiline>
        <app-multiline
          [label]="'Late Reminder Notification'"
          [(ngModel)]="this.invoiceSettings.lateReminderNotification"
          (onChanged)="handleTemplateChanged($event, 'late')"
        ></app-multiline>
      </div>
    </div>
  </div>
</div>

<!--Footer-->
<div style="position: sticky; bottom: 0; background-color: var(--colorBodyBackground); padding: 20px; margin-right: 10px; justify-content: flex-end; display: flex; gap: 10px;">
  <button class="btn-secondary" style="width: 150px;" (click)="handleCancelChanges()">Cancel</button>
  <button class="btn-primary" style="width: 150px;" (click)="handleSaveChanges()">Save</button>
</div>